//import React from 'react';
import EnthNav from '../EnthNav/EnthNav'
import "./contact.scss";

const Contact = () => {
  return (
    <div>
      <EnthNav/>
      <div className="container">
        <div className="row">
          <div class="col-3"></div>
          <div class="col-6">
            {/*<!-- Begin Constant Contact Inline Form Code -->*/}
            <div class="ctct-inline-form" data-form-id="df69fee1-0342-4de6-8ca8-8915bf16b900"></div>
            {/*<!-- End Constant Contact Inline Form Code -->*/}     
          </div>
          <div class="col-3"></div>
        </div>       
      </div>
    </div>
  )
}

export default Contact